/* eslint-disable */
// @ts-nocheck

import {
  Struct, 
	Value, 
	ListValue
} from "@bufbuild/protobuf";
import * as reboot_api from "@reboot-dev/reboot-api";
import * as reboot_web from "@reboot-dev/reboot-web";
import { v4 as uuidv4 } from "uuid";
// NOTE NOTE NOTE
//
// If you are reading this comment because you are trying to debug
// the error:
//
// Module not found: Error: Can't resolve './store_pb.js'
//
// You can resolve this by passing --web-extensions to `rbt
// generate` (or better put it in your `.rbtrc` file).
//
// This is a known issue if you're using `webpack` which uses
// `ts-loader` (https://github.com/TypeStrong/ts-loader/issues/465).
import {
  Store as StoreProto,
} from "./store_pb";
import * as store_pb from "./store_pb";
// Additionally re-export all messages_and_enums from the pb module.
export {
  Tuple,
  TableSpec,
  TablePermission,
  ZSet,
  ZTuple,
  EnsureCreatedRequest,
  EnsureCreatedResponse,
  RegisterQueryRequest,
  RegisterQueryResponse,
  MutateTableRequest,
  MutateTableResponse,
  TableStateRequest,
  TableStateResponse,
  TableChangesRequest,
  TableChangesResponse,
  QueryStateRequest,
  QueryStateResponse,
  QueryChangesRequest,
  QueryChangesResponse,
  Error,
} from "./store_pb";

import * as protobuf_es from "@bufbuild/protobuf";



const ERROR_TYPES = [
  // gRPC errors.
  reboot_api.errors_pb.Cancelled,
  reboot_api.errors_pb.Unknown,
  reboot_api.errors_pb.InvalidArgument,
  reboot_api.errors_pb.DeadlineExceeded,
  reboot_api.errors_pb.NotFound,
  reboot_api.errors_pb.AlreadyExists,
  reboot_api.errors_pb.PermissionDenied,
  reboot_api.errors_pb.ResourceExhausted,
  reboot_api.errors_pb.FailedPrecondition,
  reboot_api.errors_pb.Aborted,
  reboot_api.errors_pb.OutOfRange,
  reboot_api.errors_pb.Unimplemented,
  reboot_api.errors_pb.Internal,
  reboot_api.errors_pb.Unavailable,
  reboot_api.errors_pb.DataLoss,
  reboot_api.errors_pb.Unauthenticated,
  // Reboot errors.
  //
  // NOTE: also add any new errors into `rbt/v1alpha1/index.ts`.
  reboot_api.errors_pb.StateAlreadyConstructed,
  reboot_api.errors_pb.StateNotConstructed,
  reboot_api.errors_pb.TransactionParticipantFailedToPrepare,
  reboot_api.errors_pb.TransactionParticipantFailedToCommit,
  reboot_api.errors_pb.UnknownService,
  reboot_api.errors_pb.UnknownTask,
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!


// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const StoreEnsureCreatedRequestFromProtobufShape = (
  partialRequest: protobuf_es.PartialMessage<store_pb.EnsureCreatedRequest>
): Store.EnsureCreatedRequest => {
  // TOOD: update `convertFromProtobuf()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const request = partialRequest instanceof store_pb.EnsureCreatedRequest
    ? partialRequest
    : store_pb.EnsureCreatedRequest.fromJson(partialRequest);

  return request;
};

// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const StoreEnsureCreatedRequestFromJsonString = (
  jsonRequest: string
): Store.EnsureCreatedRequest => {
  return StoreEnsureCreatedRequestFromProtobufShape(
    store_pb.EnsureCreatedRequest.fromJsonString(jsonRequest)
  );
};

// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const StoreEnsureCreatedRequestToProtobuf = (
  partialRequest?: Store.PartialEnsureCreatedRequest
): store_pb.EnsureCreatedRequest => {
  return partialRequest instanceof store_pb.EnsureCreatedRequest
    ? partialRequest
    : new store_pb.EnsureCreatedRequest(
      partialRequest
    );
};

const StoreEnsureCreatedResponseFromProtobufShape = (
  partialResponse: protobuf_es.PartialMessage<store_pb.EnsureCreatedResponse>
) => {
  // TOOD: update `convertFromProtobuf()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const response = partialResponse instanceof store_pb.EnsureCreatedResponse
    ? partialResponse
    : store_pb.EnsureCreatedResponse.fromJson(partialResponse);

  return response;
};

const StoreEnsureCreatedResponseToProtobuf = (
  partialResponse?: Store.PartialEnsureCreatedResponse
): store_pb.EnsureCreatedResponse => {
  return partialResponse instanceof store_pb.EnsureCreatedResponse
    ? partialResponse
    : new store_pb.EnsureCreatedResponse(
      partialResponse
    );
};


// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const StoreRegisterQueryRequestFromProtobufShape = (
  partialRequest: protobuf_es.PartialMessage<store_pb.RegisterQueryRequest>
): Store.RegisterQueryRequest => {
  // TOOD: update `convertFromProtobuf()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const request = partialRequest instanceof store_pb.RegisterQueryRequest
    ? partialRequest
    : store_pb.RegisterQueryRequest.fromJson(partialRequest);

  return request;
};

// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const StoreRegisterQueryRequestFromJsonString = (
  jsonRequest: string
): Store.RegisterQueryRequest => {
  return StoreRegisterQueryRequestFromProtobufShape(
    store_pb.RegisterQueryRequest.fromJsonString(jsonRequest)
  );
};

// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const StoreRegisterQueryRequestToProtobuf = (
  partialRequest?: Store.PartialRegisterQueryRequest
): store_pb.RegisterQueryRequest => {
  return partialRequest instanceof store_pb.RegisterQueryRequest
    ? partialRequest
    : new store_pb.RegisterQueryRequest(
      partialRequest
    );
};

const StoreRegisterQueryResponseFromProtobufShape = (
  partialResponse: protobuf_es.PartialMessage<store_pb.RegisterQueryResponse>
) => {
  // TOOD: update `convertFromProtobuf()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const response = partialResponse instanceof store_pb.RegisterQueryResponse
    ? partialResponse
    : store_pb.RegisterQueryResponse.fromJson(partialResponse);

  return response;
};

const StoreRegisterQueryResponseToProtobuf = (
  partialResponse?: Store.PartialRegisterQueryResponse
): store_pb.RegisterQueryResponse => {
  return partialResponse instanceof store_pb.RegisterQueryResponse
    ? partialResponse
    : new store_pb.RegisterQueryResponse(
      partialResponse
    );
};


// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const StoreMutateTableRequestFromProtobufShape = (
  partialRequest: protobuf_es.PartialMessage<store_pb.MutateTableRequest>
): Store.MutateTableRequest => {
  // TOOD: update `convertFromProtobuf()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const request = partialRequest instanceof store_pb.MutateTableRequest
    ? partialRequest
    : store_pb.MutateTableRequest.fromJson(partialRequest);

  return request;
};

// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const StoreMutateTableRequestFromJsonString = (
  jsonRequest: string
): Store.MutateTableRequest => {
  return StoreMutateTableRequestFromProtobufShape(
    store_pb.MutateTableRequest.fromJsonString(jsonRequest)
  );
};

// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const StoreMutateTableRequestToProtobuf = (
  partialRequest?: Store.PartialMutateTableRequest
): store_pb.MutateTableRequest => {
  return partialRequest instanceof store_pb.MutateTableRequest
    ? partialRequest
    : new store_pb.MutateTableRequest(
      partialRequest
    );
};

const StoreMutateTableResponseFromProtobufShape = (
  partialResponse: protobuf_es.PartialMessage<store_pb.MutateTableResponse>
) => {
  // TOOD: update `convertFromProtobuf()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const response = partialResponse instanceof store_pb.MutateTableResponse
    ? partialResponse
    : store_pb.MutateTableResponse.fromJson(partialResponse);

  return response;
};

const StoreMutateTableResponseToProtobuf = (
  partialResponse?: Store.PartialMutateTableResponse
): store_pb.MutateTableResponse => {
  return partialResponse instanceof store_pb.MutateTableResponse
    ? partialResponse
    : new store_pb.MutateTableResponse(
      partialResponse
    );
};


// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const StoreTableStateRequestFromProtobufShape = (
  partialRequest: protobuf_es.PartialMessage<store_pb.TableStateRequest>
): Store.TableStateRequest => {
  // TOOD: update `convertFromProtobuf()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const request = partialRequest instanceof store_pb.TableStateRequest
    ? partialRequest
    : store_pb.TableStateRequest.fromJson(partialRequest);

  return request;
};

// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const StoreTableStateRequestFromJsonString = (
  jsonRequest: string
): Store.TableStateRequest => {
  return StoreTableStateRequestFromProtobufShape(
    store_pb.TableStateRequest.fromJsonString(jsonRequest)
  );
};

// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const StoreTableStateRequestToProtobuf = (
  partialRequest?: Store.PartialTableStateRequest
): store_pb.TableStateRequest => {
  return partialRequest instanceof store_pb.TableStateRequest
    ? partialRequest
    : new store_pb.TableStateRequest(
      partialRequest
    );
};

const StoreTableStateResponseFromProtobufShape = (
  partialResponse: protobuf_es.PartialMessage<store_pb.TableStateResponse>
) => {
  // TOOD: update `convertFromProtobuf()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const response = partialResponse instanceof store_pb.TableStateResponse
    ? partialResponse
    : store_pb.TableStateResponse.fromJson(partialResponse);

  return response;
};

const StoreTableStateResponseToProtobuf = (
  partialResponse?: Store.PartialTableStateResponse
): store_pb.TableStateResponse => {
  return partialResponse instanceof store_pb.TableStateResponse
    ? partialResponse
    : new store_pb.TableStateResponse(
      partialResponse
    );
};


// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const StoreTableChangesRequestFromProtobufShape = (
  partialRequest: protobuf_es.PartialMessage<store_pb.TableChangesRequest>
): Store.TableChangesRequest => {
  // TOOD: update `convertFromProtobuf()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const request = partialRequest instanceof store_pb.TableChangesRequest
    ? partialRequest
    : store_pb.TableChangesRequest.fromJson(partialRequest);

  return request;
};

// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const StoreTableChangesRequestFromJsonString = (
  jsonRequest: string
): Store.TableChangesRequest => {
  return StoreTableChangesRequestFromProtobufShape(
    store_pb.TableChangesRequest.fromJsonString(jsonRequest)
  );
};

// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const StoreTableChangesRequestToProtobuf = (
  partialRequest?: Store.PartialTableChangesRequest
): store_pb.TableChangesRequest => {
  return partialRequest instanceof store_pb.TableChangesRequest
    ? partialRequest
    : new store_pb.TableChangesRequest(
      partialRequest
    );
};

const StoreTableChangesResponseFromProtobufShape = (
  partialResponse: protobuf_es.PartialMessage<store_pb.TableChangesResponse>
) => {
  // TOOD: update `convertFromProtobuf()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const response = partialResponse instanceof store_pb.TableChangesResponse
    ? partialResponse
    : store_pb.TableChangesResponse.fromJson(partialResponse);

  return response;
};

const StoreTableChangesResponseToProtobuf = (
  partialResponse?: Store.PartialTableChangesResponse
): store_pb.TableChangesResponse => {
  return partialResponse instanceof store_pb.TableChangesResponse
    ? partialResponse
    : new store_pb.TableChangesResponse(
      partialResponse
    );
};


// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const StoreQueryStateRequestFromProtobufShape = (
  partialRequest: protobuf_es.PartialMessage<store_pb.QueryStateRequest>
): Store.QueryStateRequest => {
  // TOOD: update `convertFromProtobuf()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const request = partialRequest instanceof store_pb.QueryStateRequest
    ? partialRequest
    : store_pb.QueryStateRequest.fromJson(partialRequest);

  return request;
};

// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const StoreQueryStateRequestFromJsonString = (
  jsonRequest: string
): Store.QueryStateRequest => {
  return StoreQueryStateRequestFromProtobufShape(
    store_pb.QueryStateRequest.fromJsonString(jsonRequest)
  );
};

// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const StoreQueryStateRequestToProtobuf = (
  partialRequest?: Store.PartialQueryStateRequest
): store_pb.QueryStateRequest => {
  return partialRequest instanceof store_pb.QueryStateRequest
    ? partialRequest
    : new store_pb.QueryStateRequest(
      partialRequest
    );
};

const StoreQueryStateResponseFromProtobufShape = (
  partialResponse: protobuf_es.PartialMessage<store_pb.QueryStateResponse>
) => {
  // TOOD: update `convertFromProtobuf()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const response = partialResponse instanceof store_pb.QueryStateResponse
    ? partialResponse
    : store_pb.QueryStateResponse.fromJson(partialResponse);

  return response;
};

const StoreQueryStateResponseToProtobuf = (
  partialResponse?: Store.PartialQueryStateResponse
): store_pb.QueryStateResponse => {
  return partialResponse instanceof store_pb.QueryStateResponse
    ? partialResponse
    : new store_pb.QueryStateResponse(
      partialResponse
    );
};


// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const StoreQueryChangesRequestFromProtobufShape = (
  partialRequest: protobuf_es.PartialMessage<store_pb.QueryChangesRequest>
): Store.QueryChangesRequest => {
  // TOOD: update `convertFromProtobuf()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const request = partialRequest instanceof store_pb.QueryChangesRequest
    ? partialRequest
    : store_pb.QueryChangesRequest.fromJson(partialRequest);

  return request;
};

// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const StoreQueryChangesRequestFromJsonString = (
  jsonRequest: string
): Store.QueryChangesRequest => {
  return StoreQueryChangesRequestFromProtobufShape(
    store_pb.QueryChangesRequest.fromJsonString(jsonRequest)
  );
};

// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const StoreQueryChangesRequestToProtobuf = (
  partialRequest?: Store.PartialQueryChangesRequest
): store_pb.QueryChangesRequest => {
  return partialRequest instanceof store_pb.QueryChangesRequest
    ? partialRequest
    : new store_pb.QueryChangesRequest(
      partialRequest
    );
};

const StoreQueryChangesResponseFromProtobufShape = (
  partialResponse: protobuf_es.PartialMessage<store_pb.QueryChangesResponse>
) => {
  // TOOD: update `convertFromProtobuf()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const response = partialResponse instanceof store_pb.QueryChangesResponse
    ? partialResponse
    : store_pb.QueryChangesResponse.fromJson(partialResponse);

  return response;
};

const StoreQueryChangesResponseToProtobuf = (
  partialResponse?: Store.PartialQueryChangesResponse
): store_pb.QueryChangesResponse => {
  return partialResponse instanceof store_pb.QueryChangesResponse
    ? partialResponse
    : new store_pb.QueryChangesResponse(
      partialResponse
    );
};



export namespace Store {
  export type EnsureCreatedRequest =
    store_pb.EnsureCreatedRequest;

  export type PartialEnsureCreatedRequest =
  protobuf_es.PartialMessage<store_pb.EnsureCreatedRequest>;

  export type EnsureCreatedResponse =
    store_pb.EnsureCreatedResponse;

  export type PartialEnsureCreatedResponse =
  protobuf_es.PartialMessage<store_pb.EnsureCreatedResponse>;
}
export namespace Store {
  export type RegisterQueryRequest =
    store_pb.RegisterQueryRequest;

  export type PartialRegisterQueryRequest =
  protobuf_es.PartialMessage<store_pb.RegisterQueryRequest>;

  export type RegisterQueryResponse =
    store_pb.RegisterQueryResponse;

  export type PartialRegisterQueryResponse =
  protobuf_es.PartialMessage<store_pb.RegisterQueryResponse>;
}
export namespace Store {
  export type MutateTableRequest =
    store_pb.MutateTableRequest;

  export type PartialMutateTableRequest =
  protobuf_es.PartialMessage<store_pb.MutateTableRequest>;

  export type MutateTableResponse =
    store_pb.MutateTableResponse;

  export type PartialMutateTableResponse =
  protobuf_es.PartialMessage<store_pb.MutateTableResponse>;
}
export namespace Store {
  export type TableStateRequest =
    store_pb.TableStateRequest;

  export type PartialTableStateRequest =
  protobuf_es.PartialMessage<store_pb.TableStateRequest>;

  export type TableStateResponse =
    store_pb.TableStateResponse;

  export type PartialTableStateResponse =
  protobuf_es.PartialMessage<store_pb.TableStateResponse>;
}
export namespace Store {
  export type TableChangesRequest =
    store_pb.TableChangesRequest;

  export type PartialTableChangesRequest =
  protobuf_es.PartialMessage<store_pb.TableChangesRequest>;

  export type TableChangesResponse =
    store_pb.TableChangesResponse;

  export type PartialTableChangesResponse =
  protobuf_es.PartialMessage<store_pb.TableChangesResponse>;
}
export namespace Store {
  export type QueryStateRequest =
    store_pb.QueryStateRequest;

  export type PartialQueryStateRequest =
  protobuf_es.PartialMessage<store_pb.QueryStateRequest>;

  export type QueryStateResponse =
    store_pb.QueryStateResponse;

  export type PartialQueryStateResponse =
  protobuf_es.PartialMessage<store_pb.QueryStateResponse>;
}
export namespace Store {
  export type QueryChangesRequest =
    store_pb.QueryChangesRequest;

  export type PartialQueryChangesRequest =
  protobuf_es.PartialMessage<store_pb.QueryChangesRequest>;

  export type QueryChangesResponse =
    store_pb.QueryChangesResponse;

  export type PartialQueryChangesResponse =
  protobuf_es.PartialMessage<store_pb.QueryChangesResponse>;
}



const STORE_ENSURE_CREATED_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type StoreEnsureCreatedAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof STORE_ENSURE_CREATED_ERROR_TYPES
  >[number];

export class StoreEnsureCreatedAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      STORE_ENSURE_CREATED_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new StoreEnsureCreatedAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new StoreEnsureCreatedAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.#error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.#error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: StoreEnsureCreatedAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.#error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.#error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.#error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  get error() {
    reboot_api.assert(this.#error instanceof protobuf_es.Message);
    return this.#error;
  }

  readonly #error: StoreEnsureCreatedAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}



const STORE_REGISTER_QUERY_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type StoreRegisterQueryAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof STORE_REGISTER_QUERY_ERROR_TYPES
  >[number];

export class StoreRegisterQueryAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      STORE_REGISTER_QUERY_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new StoreRegisterQueryAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new StoreRegisterQueryAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.#error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.#error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: StoreRegisterQueryAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.#error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.#error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.#error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  get error() {
    reboot_api.assert(this.#error instanceof protobuf_es.Message);
    return this.#error;
  }

  readonly #error: StoreRegisterQueryAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}



const STORE_MUTATE_TABLE_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type StoreMutateTableAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof STORE_MUTATE_TABLE_ERROR_TYPES
  >[number];

export class StoreMutateTableAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      STORE_MUTATE_TABLE_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new StoreMutateTableAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new StoreMutateTableAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.#error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.#error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: StoreMutateTableAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.#error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.#error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.#error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  get error() {
    reboot_api.assert(this.#error instanceof protobuf_es.Message);
    return this.#error;
  }

  readonly #error: StoreMutateTableAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}



const STORE_TABLE_STATE_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type StoreTableStateAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof STORE_TABLE_STATE_ERROR_TYPES
  >[number];

export class StoreTableStateAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      STORE_TABLE_STATE_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new StoreTableStateAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new StoreTableStateAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.#error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.#error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: StoreTableStateAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.#error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.#error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.#error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  get error() {
    reboot_api.assert(this.#error instanceof protobuf_es.Message);
    return this.#error;
  }

  readonly #error: StoreTableStateAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}



const STORE_TABLE_CHANGES_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type StoreTableChangesAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof STORE_TABLE_CHANGES_ERROR_TYPES
  >[number];

export class StoreTableChangesAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      STORE_TABLE_CHANGES_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new StoreTableChangesAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new StoreTableChangesAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.#error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.#error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: StoreTableChangesAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.#error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.#error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.#error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  get error() {
    reboot_api.assert(this.#error instanceof protobuf_es.Message);
    return this.#error;
  }

  readonly #error: StoreTableChangesAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}



const STORE_QUERY_STATE_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type StoreQueryStateAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof STORE_QUERY_STATE_ERROR_TYPES
  >[number];

export class StoreQueryStateAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      STORE_QUERY_STATE_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new StoreQueryStateAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new StoreQueryStateAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.#error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.#error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: StoreQueryStateAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.#error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.#error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.#error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  get error() {
    reboot_api.assert(this.#error instanceof protobuf_es.Message);
    return this.#error;
  }

  readonly #error: StoreQueryStateAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}



const STORE_QUERY_CHANGES_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type StoreQueryChangesAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof STORE_QUERY_CHANGES_ERROR_TYPES
  >[number];

export class StoreQueryChangesAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      STORE_QUERY_CHANGES_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new StoreQueryChangesAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new StoreQueryChangesAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.#error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.#error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: StoreQueryChangesAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.#error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.#error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.#error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  get error() {
    reboot_api.assert(this.#error instanceof protobuf_es.Message);
    return this.#error;
  }

  readonly #error: StoreQueryChangesAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}


class _Reactively {
  #id: string;
  #state: string;

  constructor(id: string, options?: reboot_api.CallOptions) {
    this.#id = id;
    this.#state = "dev.moment.differential.v1alpha1.Store";
  }

  async tableState(
    context: reboot_web.WebContext,
    partialRequest?: Store.PartialTableStateRequest,
    options?: { signal?: AbortSignal },
  ): Promise<[
      AsyncGenerator<Store.TableStateResponse, void, unknown>,
      (newRequest: Store.PartialTableStateRequest) => void
    ]> {
    const request = StoreTableStateRequestToProtobuf(partialRequest);

    const [generator, setRequest] = reboot_web.reactively(
      {
        url: context.url,
        state: this.#state,
        method: "TableState",
        id: this.#id,
        requestType: store_pb.TableStateRequest,
        responseType: store_pb.TableStateResponse,
        request: request,
        signal: options?.signal,
        bearerToken: context.bearerToken,
      }
    );

    const setTypedRequest = (newRequest: Store.PartialTableStateRequest): void => {
      const typedRequest = StoreTableStateRequestToProtobuf(newRequest);
      setRequest(typedRequest);
    };

    async function* typedGenerator(): AsyncGenerator<Store.TableStateResponse, void, unknown> {
     for await (const response of generator) {
      const typedResponse = StoreTableStateResponseFromProtobufShape(response);
      yield typedResponse;
      }
    };

    return [typedGenerator(), setTypedRequest];
  }

  async tableChanges(
    context: reboot_web.WebContext,
    partialRequest?: Store.PartialTableChangesRequest,
    options?: { signal?: AbortSignal },
  ): Promise<[
      AsyncGenerator<Store.TableChangesResponse, void, unknown>,
      (newRequest: Store.PartialTableChangesRequest) => void
    ]> {
    const request = StoreTableChangesRequestToProtobuf(partialRequest);

    const [generator, setRequest] = reboot_web.reactively(
      {
        url: context.url,
        state: this.#state,
        method: "TableChanges",
        id: this.#id,
        requestType: store_pb.TableChangesRequest,
        responseType: store_pb.TableChangesResponse,
        request: request,
        signal: options?.signal,
        bearerToken: context.bearerToken,
      }
    );

    const setTypedRequest = (newRequest: Store.PartialTableChangesRequest): void => {
      const typedRequest = StoreTableChangesRequestToProtobuf(newRequest);
      setRequest(typedRequest);
    };

    async function* typedGenerator(): AsyncGenerator<Store.TableChangesResponse, void, unknown> {
     for await (const response of generator) {
      const typedResponse = StoreTableChangesResponseFromProtobufShape(response);
      yield typedResponse;
      }
    };

    return [typedGenerator(), setTypedRequest];
  }

  async queryState(
    context: reboot_web.WebContext,
    partialRequest?: Store.PartialQueryStateRequest,
    options?: { signal?: AbortSignal },
  ): Promise<[
      AsyncGenerator<Store.QueryStateResponse, void, unknown>,
      (newRequest: Store.PartialQueryStateRequest) => void
    ]> {
    const request = StoreQueryStateRequestToProtobuf(partialRequest);

    const [generator, setRequest] = reboot_web.reactively(
      {
        url: context.url,
        state: this.#state,
        method: "QueryState",
        id: this.#id,
        requestType: store_pb.QueryStateRequest,
        responseType: store_pb.QueryStateResponse,
        request: request,
        signal: options?.signal,
        bearerToken: context.bearerToken,
      }
    );

    const setTypedRequest = (newRequest: Store.PartialQueryStateRequest): void => {
      const typedRequest = StoreQueryStateRequestToProtobuf(newRequest);
      setRequest(typedRequest);
    };

    async function* typedGenerator(): AsyncGenerator<Store.QueryStateResponse, void, unknown> {
     for await (const response of generator) {
      const typedResponse = StoreQueryStateResponseFromProtobufShape(response);
      yield typedResponse;
      }
    };

    return [typedGenerator(), setTypedRequest];
  }

  async queryChanges(
    context: reboot_web.WebContext,
    partialRequest?: Store.PartialQueryChangesRequest,
    options?: { signal?: AbortSignal },
  ): Promise<[
      AsyncGenerator<Store.QueryChangesResponse, void, unknown>,
      (newRequest: Store.PartialQueryChangesRequest) => void
    ]> {
    const request = StoreQueryChangesRequestToProtobuf(partialRequest);

    const [generator, setRequest] = reboot_web.reactively(
      {
        url: context.url,
        state: this.#state,
        method: "QueryChanges",
        id: this.#id,
        requestType: store_pb.QueryChangesRequest,
        responseType: store_pb.QueryChangesResponse,
        request: request,
        signal: options?.signal,
        bearerToken: context.bearerToken,
      }
    );

    const setTypedRequest = (newRequest: Store.PartialQueryChangesRequest): void => {
      const typedRequest = StoreQueryChangesRequestToProtobuf(newRequest);
      setRequest(typedRequest);
    };

    async function* typedGenerator(): AsyncGenerator<Store.QueryChangesResponse, void, unknown> {
     for await (const response of generator) {
      const typedResponse = StoreQueryChangesResponseFromProtobufShape(response);
      yield typedResponse;
      }
    };

    return [typedGenerator(), setTypedRequest];
  }

}

class _Idempotently {
  #stateRef: string;
  #idempotencyKey: string;

  constructor(id: string, idempotencyKey: string, options?: reboot_api.CallOptions) {
    this.#stateRef = reboot_api.stateIdToRef("dev.moment.differential.v1alpha1.Store", id);
    this.#idempotencyKey = idempotencyKey;
  }

  async ensureCreated(
    context: reboot_web.WebContext,
    partialRequest?: Store.PartialEnsureCreatedRequest,
    options?: { signal?: AbortSignal },
  ): Promise<Store.EnsureCreatedResponse> {
    const request = StoreEnsureCreatedRequestToProtobuf(partialRequest);

    const responseProtobuf = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.differential.v1alpha1.StoreMethods/EnsureCreated",
        stateRef: this.#stateRef,
        requestType: store_pb.EnsureCreatedRequest,
        responseType: store_pb.EnsureCreatedResponse,
        abortedType: StoreEnsureCreatedAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: this.#idempotencyKey,
      });

    return StoreEnsureCreatedResponseFromProtobufShape(responseProtobuf);
  }

  async registerQuery(
    context: reboot_web.WebContext,
    partialRequest?: Store.PartialRegisterQueryRequest,
    options?: { signal?: AbortSignal },
  ): Promise<Store.RegisterQueryResponse> {
    const request = StoreRegisterQueryRequestToProtobuf(partialRequest);

    const responseProtobuf = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.differential.v1alpha1.StoreMethods/RegisterQuery",
        stateRef: this.#stateRef,
        requestType: store_pb.RegisterQueryRequest,
        responseType: store_pb.RegisterQueryResponse,
        abortedType: StoreRegisterQueryAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: this.#idempotencyKey,
      });

    return StoreRegisterQueryResponseFromProtobufShape(responseProtobuf);
  }

  async mutateTable(
    context: reboot_web.WebContext,
    partialRequest?: Store.PartialMutateTableRequest,
    options?: { signal?: AbortSignal },
  ): Promise<Store.MutateTableResponse> {
    const request = StoreMutateTableRequestToProtobuf(partialRequest);

    const responseProtobuf = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.differential.v1alpha1.StoreMethods/MutateTable",
        stateRef: this.#stateRef,
        requestType: store_pb.MutateTableRequest,
        responseType: store_pb.MutateTableResponse,
        abortedType: StoreMutateTableAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: this.#idempotencyKey,
      });

    return StoreMutateTableResponseFromProtobufShape(responseProtobuf);
  }

}

export class StoreWeakReference {
  #id: string;
  #options?: reboot_api.CallOptions;

  constructor(id: string) {
    this.#id = id;
  }

  get stateId(): string {
    return this.#id;
  }

  public reactively() {
    return new _Reactively(
      this.#id,
    );
  }

  public idempotently({ key }: { key: string }) {
    return new _Idempotently(
      this.#id,
      key,
    );
  }


  async ensureCreated(
    context: reboot_web.WebContext,
    partialRequest?: Store.PartialEnsureCreatedRequest,
    options?: { signal?: AbortSignal, from_constructor?: boolean },
  ): Promise<Store.EnsureCreatedResponse> {

    const request = StoreEnsureCreatedRequestToProtobuf(partialRequest);

    const stateRef = reboot_api.stateIdToRef(
      "dev.moment.differential.v1alpha1.Store",
      this.#id,
    );
    const idempotencyKey = uuidv4();

    const protobufResponse = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.differential.v1alpha1.StoreMethods/EnsureCreated",
        stateRef: stateRef,
        requestType: store_pb.EnsureCreatedRequest,
        responseType: store_pb.EnsureCreatedResponse,
        abortedType: StoreEnsureCreatedAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: idempotencyKey,
      });

    return StoreEnsureCreatedResponseFromProtobufShape(protobufResponse);
  }


  async registerQuery(
    context: reboot_web.WebContext,
    partialRequest?: Store.PartialRegisterQueryRequest,
    options?: { signal?: AbortSignal, from_constructor?: boolean },
  ): Promise<Store.RegisterQueryResponse> {

    const request = StoreRegisterQueryRequestToProtobuf(partialRequest);

    const stateRef = reboot_api.stateIdToRef(
      "dev.moment.differential.v1alpha1.Store",
      this.#id,
    );
    const idempotencyKey = uuidv4();

    const protobufResponse = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.differential.v1alpha1.StoreMethods/RegisterQuery",
        stateRef: stateRef,
        requestType: store_pb.RegisterQueryRequest,
        responseType: store_pb.RegisterQueryResponse,
        abortedType: StoreRegisterQueryAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: idempotencyKey,
      });

    return StoreRegisterQueryResponseFromProtobufShape(protobufResponse);
  }


  async mutateTable(
    context: reboot_web.WebContext,
    partialRequest?: Store.PartialMutateTableRequest,
    options?: { signal?: AbortSignal, from_constructor?: boolean },
  ): Promise<Store.MutateTableResponse> {

    const request = StoreMutateTableRequestToProtobuf(partialRequest);

    const stateRef = reboot_api.stateIdToRef(
      "dev.moment.differential.v1alpha1.Store",
      this.#id,
    );
    const idempotencyKey = uuidv4();

    const protobufResponse = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.differential.v1alpha1.StoreMethods/MutateTable",
        stateRef: stateRef,
        requestType: store_pb.MutateTableRequest,
        responseType: store_pb.MutateTableResponse,
        abortedType: StoreMutateTableAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: idempotencyKey,
      });

    return StoreMutateTableResponseFromProtobufShape(protobufResponse);
  }


  async tableState(
    context: reboot_web.WebContext,
    partialRequest?: Store.PartialTableStateRequest,
    options?: { signal?: AbortSignal, from_constructor?: boolean },
  ): Promise<Store.TableStateResponse> {

    const request = StoreTableStateRequestToProtobuf(partialRequest);

    const stateRef = reboot_api.stateIdToRef(
      "dev.moment.differential.v1alpha1.Store",
      this.#id,
    );
    const idempotencyKey = uuidv4();

    const protobufResponse = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.differential.v1alpha1.StoreMethods/TableState",
        stateRef: stateRef,
        requestType: store_pb.TableStateRequest,
        responseType: store_pb.TableStateResponse,
        abortedType: StoreTableStateAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: idempotencyKey,
      });

    return StoreTableStateResponseFromProtobufShape(protobufResponse);
  }


  async tableChanges(
    context: reboot_web.WebContext,
    partialRequest?: Store.PartialTableChangesRequest,
    options?: { signal?: AbortSignal, from_constructor?: boolean },
  ): Promise<Store.TableChangesResponse> {

    const request = StoreTableChangesRequestToProtobuf(partialRequest);

    const stateRef = reboot_api.stateIdToRef(
      "dev.moment.differential.v1alpha1.Store",
      this.#id,
    );
    const idempotencyKey = uuidv4();

    const protobufResponse = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.differential.v1alpha1.StoreMethods/TableChanges",
        stateRef: stateRef,
        requestType: store_pb.TableChangesRequest,
        responseType: store_pb.TableChangesResponse,
        abortedType: StoreTableChangesAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: idempotencyKey,
      });

    return StoreTableChangesResponseFromProtobufShape(protobufResponse);
  }


  async queryState(
    context: reboot_web.WebContext,
    partialRequest?: Store.PartialQueryStateRequest,
    options?: { signal?: AbortSignal, from_constructor?: boolean },
  ): Promise<Store.QueryStateResponse> {

    const request = StoreQueryStateRequestToProtobuf(partialRequest);

    const stateRef = reboot_api.stateIdToRef(
      "dev.moment.differential.v1alpha1.Store",
      this.#id,
    );
    const idempotencyKey = uuidv4();

    const protobufResponse = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.differential.v1alpha1.StoreMethods/QueryState",
        stateRef: stateRef,
        requestType: store_pb.QueryStateRequest,
        responseType: store_pb.QueryStateResponse,
        abortedType: StoreQueryStateAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: idempotencyKey,
      });

    return StoreQueryStateResponseFromProtobufShape(protobufResponse);
  }


  async queryChanges(
    context: reboot_web.WebContext,
    partialRequest?: Store.PartialQueryChangesRequest,
    options?: { signal?: AbortSignal, from_constructor?: boolean },
  ): Promise<Store.QueryChangesResponse> {

    const request = StoreQueryChangesRequestToProtobuf(partialRequest);

    const stateRef = reboot_api.stateIdToRef(
      "dev.moment.differential.v1alpha1.Store",
      this.#id,
    );
    const idempotencyKey = uuidv4();

    const protobufResponse = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.differential.v1alpha1.StoreMethods/QueryChanges",
        stateRef: stateRef,
        requestType: store_pb.QueryChangesRequest,
        responseType: store_pb.QueryChangesResponse,
        abortedType: StoreQueryChangesAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: idempotencyKey,
      });

    return StoreQueryChangesResponseFromProtobufShape(protobufResponse);
  }

}

export class Store {

  static WeakReference = StoreWeakReference;

  public static ref(
    id: string,
    options?: { bearerToken?: string }
  ) {
    return new Store.WeakReference(id, options?.bearerToken);
  }



}

export namespace Store {
  export type WeakReference = typeof Store.WeakReference.prototype;
}

